/* Old IN-CART-UPSELLS-TEST L-Carnitine buy box (sections/jx-legacy-hero.liquid).
   Gallery slider + thumbnails, the Buy 1/2/3 bundle box (rebuilt from the old Kaching design: tiers, per-bottle flavour
   dropdowns, savings line, sticky "Choose bundle" bar), welcome-gift unlocks, the "Try it once" link, ship-by date, and Add to cart.
   Add to cart posts one line per flavour on the 4-week plan and opens the theme's cart drawer the same way
   assets/jx-buy-box.js does; assets/jx-gifts.js then adds the free gift lines. */
(function () {
  function init(root) {
    if (root.__jxl) return;
    root.__jxl = true;
    var scope = root.closest('[data-jxl-scope]') || root;
    var variantsEl = scope.parentElement && scope.parentElement.querySelector('[data-jxl-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (e) { variants = []; }

    /* ---------- gallery ---------- */
    var list = root.querySelector('[id^="Slider-Gallery"]');
    var slides = list ? Array.prototype.slice.call(list.querySelectorAll('[data-jxl-index]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[id^="Slider-Thumbnails"] [data-jxl-index]'));
    var counter = root.querySelector('.jxl-slider-counter--current');
    var current = 0;

    function setActive(i) {
      current = i;
      slides.forEach(function (s, n) { s.classList.toggle('jxl-is-active', n === i); });
      thumbs.forEach(function (t, n) {
        var b = t.querySelector('button');
        if (!b) return;
        if (n === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = i + 1;
    }
    function goTo(i) {
      if (!slides[i] || !list) return;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: 'smooth' });
      setActive(i);
      var t = thumbs[i];
      var tl = t && t.parentElement;
      if (tl) tl.scrollTo({ left: t.offsetLeft - tl.offsetLeft - (tl.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
    }
    if (list) {
      var raf = null;
      list.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = slides[0] ? slides[0].clientWidth : list.clientWidth;
          if (!w) return;
          var i = Math.round(list.scrollLeft / w);
          if (i !== current && slides[i]) setActive(i);
        });
      }, { passive: true });
    }
    thumbs.forEach(function (t, n) {
      var b = t.querySelector('button');
      if (b) b.addEventListener('click', function () { goTo(n); });
    });
    root.querySelectorAll('.jxl-slider-button--prev, .jxl-slider-button--next').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.classList.contains('jxl-slider-button--next');
        var thumbList = btn.closest('[id^="GalleryThumbnails"]');
        if (thumbList) {
          var tl = thumbList.querySelector('ul');
          if (tl) tl.scrollBy({ left: (next ? 1 : -1) * tl.clientWidth * 0.8, behavior: 'smooth' });
          return;
        }
        goTo(Math.max(0, Math.min(slides.length - 1, current + (next ? 1 : -1))));
      });
    });

    /* ---------- bundle box (Buy 1 / 2 / 3) ---------- */
    var box = root.querySelector('[data-jxk]');
    var bars = box ? Array.prototype.slice.call(box.querySelectorAll('[data-jxk-bar]')) : [];
    var savingEl = box && box.querySelector('[data-jxk-saving]');
    var savingWrap = box && box.querySelector('[data-jxk-saving-wrap]');
    var optionsTpl = box && box.querySelector('template[data-jxk-options]');
    var gifts = Array.prototype.slice.call(root.querySelectorAll('.jxl-jcked-gift[data-unlock]'));
    var reward = root.querySelector('[data-jxl-reward]');

    function selectedBar() {
      return bars.find(function (b) { return b.classList.contains('jxl-kaching-bundles__bar--selected'); }) || bars[0];
    }
    function selectedQty() {
      var b = selectedBar();
      return b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : 1;
    }
    /* Subscribe & Save checkbox (snippets/jx-purchase-options.liquid, loner pages): unticked = a one-time purchase */
    var subBox = root.querySelector('[data-jxl-sub-box]');
    function isOnce() {
      return !!subBox && !subBox.checked;
    }
    function syncBundle() {
      var b = selectedBar();
      var once = isOnce();
      if (savingEl && b) {
        savingEl.textContent = b.getAttribute(once ? 'data-saving-once' : 'data-saving') || '';
        if (savingWrap) savingWrap.hidden = !(parseInt(b.getAttribute(once ? 'data-saving-once-cents' : 'data-saving-cents'), 10) > 0);
      }
      var n = selectedQty();
      gifts.forEach(function (g) { g.classList.toggle('jxl-is-locked', once || n < parseInt(g.getAttribute('data-unlock'), 10)); });
      if (subBox) scope.classList.toggle('jxl-mode-once', once);
      /* The percent on the checkbox is per bundle: it counts the gifts that bundle earns */
      var pctEl = root.querySelector('[data-jxl-sub-pct]');
      if (pctEl && b && b.getAttribute('data-sub-pct')) pctEl.textContent = b.getAttribute('data-sub-pct');
      /* Gift set "Tiered gifts": gift 4 shows the state for this bundle (1 locked, 2 sachets, 3 the refill kit) */
      if (reward) reward.setAttribute('data-jxl-reward', String(Math.min(Math.max(n, 1), 3)));
      syncOnce();
    }
    /* "Try it once" link: the one-time offer page with the selected bundle, its bottles (&bottles=) and each bottle's flavour
       as a variant id (&flavors=, the format assets/jx-bundle.js reads there), labelled with that page's price for them */
    var onceLink = root.querySelector('[data-jxl-once]');
    function syncOnce() {
      if (!onceLink) return;
      var count = Math.min(Math.max(1, selectedQty()), 5);
      var bar = selectedBar();
      var picks = bar ? Array.prototype.slice.call(bar.querySelectorAll('[data-jxk-slot]')).map(function (sl) {
        var value = sl.getAttribute('data-value');
        var v = variants.find(function (x) { return x.option1 === value; });
        return v ? v.id : null;
      }).filter(Boolean).slice(0, count) : [];
      var label = onceLink.getAttribute('data-label-' + count);
      if (label) onceLink.textContent = label;
      var href = onceLink.getAttribute('href').replace(/&(bottles|flavors)=[^&]*/g, '');
      onceLink.setAttribute('href', href + (count > 1 ? '&bottles=' + count : '') + (picks.length ? '&flavors=' + picks.join(',') : ''));
    }
    if (subBox) {
      subBox.addEventListener('change', syncBundle);
      var kitHead = root.querySelector('.jxl-jcked-welcome-kit__header');
      if (kitHead) {
        var kitNote = document.createElement('p');
        kitNote.className = 'jxl-subbox-note jxl-if-once';
        kitNote.textContent = 'Free gifts come with Subscribe & Save';
        kitHead.insertAdjacentElement('afterend', kitNote);
      }
    }
    bars.forEach(function (bar) {
      var radio = bar.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        closeDropdown();
        bars.forEach(function (x) { x.classList.toggle('jxl-kaching-bundles__bar--selected', x === bar); });
        syncBundle();
      });
      var main = bar.querySelector('.jxl-kaching-bundles__bar-main');
      if (main) main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    /* flavour dropdown, one open at a time, built from the <template> */
    var open = null;
    function closeDropdown() {
      if (!open) return;
      open.list.remove();
      open.combo.setAttribute('aria-expanded', 'false');
      open = null;
    }
    function setSlot(slot, value, image) {
      slot.setAttribute('data-value', value);
      var label = slot.querySelector('[data-jxk-label]');
      if (label) label.textContent = value;
      var sw = slot.querySelector('.jxl-kaching-bundles__swatch');
      if (sw && image) sw.style.setProperty('--kaching-swatch-image-url', 'url(' + image + ')');
    }
    function openDropdown(slot) {
      var combo = slot.querySelector('[role="combobox"]');
      if (!optionsTpl || !combo) return;
      closeDropdown();
      var bounds = visibleBounds();
      var list = optionsTpl.content.firstElementChild.cloneNode(true);
      var value = slot.getAttribute('data-value');
      Array.prototype.forEach.call(list.querySelectorAll('[role="option"]'), function (opt) {
        var on = opt.getAttribute('data-value') === value;
        opt.setAttribute('aria-selected', on ? 'true' : 'false');
        opt.classList.toggle('jxl-kaching-bundles__swatch-dropdown__option--focused', on);
        opt.addEventListener('mouseenter', function () {
          list.querySelectorAll('.jxl-kaching-bundles__swatch-dropdown__option--focused').forEach(function (o) { o.classList.remove('jxl-kaching-bundles__swatch-dropdown__option--focused'); });
          opt.classList.add('jxl-kaching-bundles__swatch-dropdown__option--focused');
        });
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setSlot(slot, opt.getAttribute('data-value'), opt.getAttribute('data-image'));
          syncOnce();
          closeDropdown();
          combo.focus();
        });
      });
      slot.appendChild(list);
      combo.setAttribute('aria-expanded', 'true');
      open = { list: list, combo: combo, slot: slot };
      /* the list is position: fixed (Kaching's CSS): under the select, or above it when there is no room below, kept
         between the fixed header and any fixed bottom bar so every flavour stays on screen */
      list.style.maxHeight = Math.max(160, bounds.bottom - bounds.top - 8) + 'px';
      var cr = combo.getBoundingClientRect();
      var h = list.offsetHeight;
      var w = list.offsetWidth;
      var top = cr.bottom + h <= bounds.bottom ? cr.bottom : cr.top - h;
      list.style.left = Math.max(4, Math.min(cr.left, window.innerWidth - w - 4)) + 'px';
      list.style.top = Math.max(bounds.top + 4, Math.min(top, bounds.bottom - h - 4)) + 'px';
    }
    /* the part of the viewport not covered by fixed/sticky bars (the theme header on top, sticky Add to cart below) */
    function coveringBar(x, y) {
      var el = document.elementFromPoint(x, y);
      for (; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
        var pos = getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') return el.getBoundingClientRect();
      }
      return null;
    }
    function visibleBounds() {
      var vh = window.innerHeight, x = window.innerWidth / 2;
      var t = coveringBar(x, 2), b = coveringBar(x, vh - 2);
      return {
        top: t && t.bottom < vh / 2 ? Math.max(0, t.bottom) : 0,
        bottom: b && b.top > vh / 2 ? Math.min(vh, b.top) : vh
      };
    }
    window.addEventListener('scroll', function () { if (open && !open.list.contains(document.activeElement)) closeDropdown(); }, { passive: true });
    window.addEventListener('resize', function () { closeDropdown(); });
    if (box) {
      box.addEventListener('click', function (e) {
        var combo = e.target.closest('[role="combobox"]');
        if (!combo) return;
        e.preventDefault();
        e.stopPropagation();
        var slot = combo.closest('[data-jxk-slot]');
        if (open && open.slot === slot) { closeDropdown(); return; }
        openDropdown(slot);
      });
      box.addEventListener('keydown', function (e) {
        var combo = e.target.closest('[role="combobox"]');
        if (combo && (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown')) {
          e.preventDefault();
          openDropdown(combo.closest('[data-jxk-slot]'));
          var first = open && (open.list.querySelector('[aria-selected="true"]') || open.list.querySelector('[role="option"]'));
          if (first) first.focus();
          return;
        }
        if (!open) return;
        var opts = Array.prototype.slice.call(open.list.querySelectorAll('[role="option"]'));
        var i = opts.indexOf(document.activeElement);
        if (e.key === 'Escape') { e.preventDefault(); var c = open.combo; closeDropdown(); c.focus(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
        else if ((e.key === 'Enter' || e.key === ' ') && i > -1) { e.preventDefault(); opts[i].click(); }
      });
    }
    document.addEventListener('click', function (e) { if (open && !open.slot.contains(e.target)) closeDropdown(); });
    syncBundle();

    /* sticky "Choose bundle" bar: shown while the bundle box is off screen */
    var sticky = scope.querySelector('[data-jxk-sticky]');
    var block = box && box.querySelector('.jxl-kaching-bundles__block');
    if (sticky && block && 'IntersectionObserver' in window) {
      /* page level, like Kaching's bar, so later sections can't paint over it; the wrapper keeps the scoped styles */
      if (sticky.parentElement && !sticky.parentElement.hasAttribute('data-jxk-sticky-host')) {
        var stickyHost = document.querySelector('[data-jxk-sticky-host]');
        if (stickyHost) stickyHost.remove();
        stickyHost = document.createElement('div');
        stickyHost.className = 'jxl-scope';
        stickyHost.setAttribute('data-jxk-sticky-host', '');
        stickyHost.appendChild(sticky);
        document.body.appendChild(stickyHost);
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('jxl-kaching-bundles-sticky-atc--visible', !en.isIntersecting); });
      }).observe(block);
      var stickyBtn = sticky.querySelector('[data-jxk-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { block.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    /* ---------- ship-by date (today + 2 days) ---------- */
    var ship = root.querySelector('[data-jxl-ship-date]');
    if (ship) {
      var d = new Date();
      d.setDate(d.getDate() + 2);
      ship.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric' });
    }

    /* ---------- add to cart: one line per flavour in the chosen bundle ---------- */
    var form = root.querySelector('form[action*="/cart/add"]');
    var btn = form && form.querySelector('[type="submit"]');
    var idInput = root.querySelector('[data-jxl-variant]');
    var errorWrap = root.querySelector('.jxl-product-form__error-message-wrapper');
    var errorMsg = root.querySelector('.jxl-product-form__error-message');
    function showError(msg) {
      if (!errorWrap) return;
      errorWrap.hidden = !msg;
      if (errorMsg) errorMsg.textContent = msg || '';
    }
    function lines() {
      var bar = selectedBar();
      var slots = bar ? Array.prototype.slice.call(bar.querySelectorAll('[data-jxk-slot]')) : [];
      var tally = {};
      var order = [];
      slots.forEach(function (s) {
        var v = s.getAttribute('data-value');
        if (!(v in tally)) { tally[v] = 0; order.push(v); }
        tally[v] += 1;
      });
      if (!order.length && idInput) return [{ id: idInput.value, quantity: selectedQty() }];
      return order.map(function (value) {
        var v = variants.find(function (x) { return x.option1 === value; });
        return v ? { id: v.id, quantity: tally[value] } : null;
      });
    }
    if (form && btn) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var items = lines();
        if (!items.length || items.some(function (l) { return !l; })) { showError('Sorry, this is not currently available.'); return; }
        showError(false);
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('jxl-loading');
        var spinner = btn.querySelector('.jxl-loading-overlay__spinner');
        if (spinner) spinner.classList.remove('jxl-hidden');

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var plan = form.querySelector('[data-jxl-plan]');
        var fd = new FormData();
        items.forEach(function (l, i) {
          fd.append('items[' + i + '][id]', l.id);
          fd.append('items[' + i + '][quantity]', l.quantity);
          /* Try it once: a plain one-time line at the product's own price (no plan, gifts or cart saving) */
          if (isOnce()) return;
          if (plan && plan.value) fd.append('items[' + i + '][selling_plan]', plan.value);
          /* Gift sets "Monthly gifts" / "Tiered gifts": jx-gifts.js adds that set's gifts for bottles tagged this way */
          if (form.getAttribute('data-gift-track')) fd.append('items[' + i + '][properties][_jx_gift_track]', form.getAttribute('data-gift-track'));
          /* "Cart saving shown": the cart drawer sets the compare-at total so the cart shows this saving */
          if (form.getAttribute('data-cart-off')) fd.append('items[' + i + '][properties][_jx_off]', form.getAttribute('data-cart-off'));
        });
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        var canPublish = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
        var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(url + '.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              showError(res.description || res.message);
              if (canPublish) publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: items[0].id, errors: res.errors || res.description, message: res.message });
              return;
            }
            if (!cart || typeof cart.renderContents !== 'function') { window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'; return; }
            if (canPublish) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res });
            cart.renderContents(res);
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(function (e) { console.error(e); showError('Something went wrong. Please try again.'); })
          .finally(function () {
            btn.classList.remove('jxl-loading');
            btn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('jxl-hidden');
          });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-jxl-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
